import { Link } from "react-router-dom";
import { Lock, BookMarked } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

/* Friendly notice for a commentary the viewer may not read (401 sign-in / 403 admins / 404 hidden). */
export function CommentaryAccessNotice({ error, compact = false }) {
  const { openAuth } = useAuth();
  const status = error?.response?.status;
  const needsLogin = status === 401;
  const title = needsLogin ? "Sign in to read this commentary" : "This commentary isn't available";
  const body = needsLogin ? "This commentary is reserved for members. Create a free account or sign in to keep reading." : status === 403 ? "It's currently limited to site admins." : "It may have been turned off by the site admins.";
  return (
    <div className={`rounded-2xl border border-dashed border-border bg-card text-center ${compact ? "p-5" : "p-10"}`} data-testid="commentary-access-notice" data-status={status}>
      <Lock className="mx-auto h-6 w-6 text-gold" />
      <h2 className={`mt-3 font-serif font-semibold text-foreground ${compact ? "text-lg" : "text-2xl"}`}>{title}</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">{body}</p>
      <div className="mt-5 flex flex-wrap justify-center gap-2">
        {needsLogin && <Button onClick={openAuth} className="rounded-full bg-primary text-primary-foreground" data-testid="commentary-access-signin">Sign in</Button>}
        {!compact && <Button asChild variant="outline" className="rounded-full"><Link to="/commentary" data-testid="commentary-access-back"><BookMarked className="mr-2 h-4 w-4" /> Other commentaries</Link></Button>}
      </div>
    </div>
  );
}

export const isAccessError = (error) => [401, 403, 404].includes(error?.response?.status);
